import { createEvent, sample } from 'effector'
import { epgCategoriesModel } from '~/entities/epg/categories'
import { LOAD_MORE_COUNT } from './index.h'

export const load = createEvent()

// load more categories
// it takes curretly loaded categories count, calculates page number to load and loads next page
sample({
  clock: load,
  source: {
    loaded: epgCategoriesModel.$loaded,
    hasMore: epgCategoriesModel.$hasMore,
    pending: epgCategoriesModel.loadPageFx.pending,
  },
  filter: ({ hasMore, pending }) => hasMore && !pending,
  fn: ({ loaded }) => ({
    page: Math.floor(loaded.length / LOAD_MORE_COUNT),
    count: LOAD_MORE_COUNT,
  }),
  target: epgCategoriesModel.loadPageFx,
})
